import React from "react"
type Props = {
  name: string
  post: string
  para: string
}
const TestimonialCaption: React.FC<Props> = ({ name, post, para }) => {
  return (
    <div
      className="card p-[30px] mb-10 bg-white"
     
    >
      <div className="card-body flex flex-col justify-between">
        <div className="card-description mb-5">
          <p className="card-text fw-400 fs-md fs-mdlg">{para}</p>
        </div>
        <div>
          <p className="card-title mb-0 fs-lg fw-700 text-textcolor">{name}</p>
          <p className="card-text fs-md fs-mdlg fw-600">{post}</p>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCaption
